export class TalkRoomDisplayOrder {
  constructor(
    public talkRoomId: string,
    public displayOrder: number,
  ) {}
}
